module.exports = __webpack_public_path__ + "img/skylight.15b9591.svg";